import React from 'react';
import AppModal from '../../common/AppModal';
import type { SpatialExportFormat } from '../../../types/baseExplorerConfig';

export type ExplorerExportFormat = 'csv' | SpatialExportFormat;

const LABELS: Record<ExplorerExportFormat, string> = {
  csv: 'CSV',
  shapefile: 'Shapefile (WGS 84)',
  geojson: 'GeoJSON (WGS 84)',
  kml: 'KML (WGS 84)',
};

interface ExportFormatModalProps {
  isOpen: boolean;
  formats: ExplorerExportFormat[];
  onClose: () => void;
  onExport: (format: ExplorerExportFormat) => void;
}

/** Export format choice for an explorer that offers more than CSV (#875); same shape as the Duty Log export dialog. */
const ExportFormatModal: React.FC<ExportFormatModalProps> = ({ isOpen, formats, onClose, onExport }) => (
  <AppModal isOpen={isOpen} onClose={onClose} header="Export" width={420}>
    <p>Choose export format:</p>
    <div className="cbe-export-buttons">
      {formats.map((f) => (
        <button key={f} className="btn btn-primary" onClick={() => onExport(f)}>{LABELS[f]}</button>
      ))}
    </div>
    <div style={{ marginTop: '16px', textAlign: 'right' }}>
      <button className="btn btn-neutral" onClick={onClose}>Cancel</button>
    </div>
  </AppModal>
);

export default ExportFormatModal;
